module.exports = __webpack_public_path__ + "static/media/logo-ontest.d0116f29.png";